import React from 'react'

const ProjectsSection = () => {
  return (
    <div>
      <section className="hero is-primary is-medium">
        <div className="hero-body">
          <div className="container">
            <h1 className="title">
        NASA TechPort
            </h1>
            <h2 className="subtitle">
        Please choose a project from the options below, ordered by date; discover the technologies NASA is working on every day to explore space, understand the universe, and improve aeronautics. NASA is developing technologies in areas such as propulsion, nanotechnology, robotics, and human health. 
            </h2>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ProjectsSection